/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputUavMissionsReportDay } from './OutputUavMissionsReportDay';
import {
    OutputUavMissionsReportDayFromJSON,
    OutputUavMissionsReportDayFromJSONTyped,
    OutputUavMissionsReportDayToJSON,
} from './OutputUavMissionsReportDay';
import type { OutputUavMissionsReportFilter } from './OutputUavMissionsReportFilter';
import {
    OutputUavMissionsReportFilterFromJSON,
    OutputUavMissionsReportFilterFromJSONTyped,
    OutputUavMissionsReportFilterToJSON,
} from './OutputUavMissionsReportFilter';
import type { OutputUavMissionsReportSection } from './OutputUavMissionsReportSection';
import {
    OutputUavMissionsReportSectionFromJSON,
    OutputUavMissionsReportSectionFromJSONTyped,
    OutputUavMissionsReportSectionToJSON,
} from './OutputUavMissionsReportSection';

/**
 * 
 * @export
 * @interface OutputUavMissionsReport
 */
export interface OutputUavMissionsReport {
    /**
     * DayStartHour — година початку доби (0..23), за якою нарізано Days.
     * @type {number}
     * @memberof OutputUavMissionsReport
     */
    dayStartHour: number;
    /**
     * 
     * @type {Array<OutputUavMissionsReportDay>}
     * @memberof OutputUavMissionsReport
     */
    days: Array<OutputUavMissionsReportDay>;
    /**
     * Filters — інші обрані фільтри історії поіменно (крім періоду й корпусу).
     * @type {Array<OutputUavMissionsReportFilter>}
     * @memberof OutputUavMissionsReport
     */
    filters: Array<OutputUavMissionsReportFilter>;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReport
     */
    flights: number;
    /**
     * OtgNames — корпуси, у смузі яких складено звіт: вибрані у фільтрі або корпус
     * користувача з корпусною роллю. Порожньо = без обмеження по корпусу.
     * @type {Array<string>}
     * @memberof OutputUavMissionsReport
     */
    otgNames: Array<string>;
    /**
     * PeriodFrom/PeriodTo — межі періоду за київським часом ("YYYY-MM-DD HH:MM"), кінець не
     * включно: доба ПУ 08:00 — це "2026-10-09 08:00" → "2026-10-10 08:00". null = за весь час.
     * @type {string}
     * @memberof OutputUavMissionsReport
     */
    periodFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionsReport
     */
    periodTo?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReport
     */
    requests: number;
    /**
     * RequestsOnBoard/RequestsUpcoming — частина Requests, якої ще немає в історії: заявки на
     * борді та заплановані на майбутні дати. Requests − обидва = лічильник історії.
     * @type {number}
     * @memberof OutputUavMissionsReport
     */
    requestsOnBoard: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionsReport
     */
    requestsUpcoming: number;
    /**
     * 
     * @type {Array<OutputUavMissionsReportSection>}
     * @memberof OutputUavMissionsReport
     */
    sections: Array<OutputUavMissionsReportSection>;
    /**
     * Shootdowns — кількість збиттів (uav_mission_shootdowns) за часом події.
     * @type {number}
     * @memberof OutputUavMissionsReport
     */
    shootdowns: number;
}

/**
 * Check if a given object implements the OutputUavMissionsReport interface.
 */
export function instanceOfOutputUavMissionsReport(value: object): boolean {
    if (!('dayStartHour' in value)) return false;
    if (!('days' in value)) return false;
    if (!('filters' in value)) return false;
    if (!('flights' in value)) return false;
    if (!('otgNames' in value)) return false;
    if (!('requests' in value)) return false;
    if (!('requestsOnBoard' in value)) return false;
    if (!('requestsUpcoming' in value)) return false;
    if (!('sections' in value)) return false;
    if (!('shootdowns' in value)) return false;
    return true;
}

export function OutputUavMissionsReportFromJSON(json: any): OutputUavMissionsReport {
    return OutputUavMissionsReportFromJSONTyped(json, false);
}

export function OutputUavMissionsReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionsReport {
    if (json == null) {
        return json;
    }
    return {
        
        'dayStartHour': json['dayStartHour'],
        'days': ((json['days'] as Array<any>).map(OutputUavMissionsReportDayFromJSON)),
        'filters': ((json['filters'] as Array<any>).map(OutputUavMissionsReportFilterFromJSON)),
        'flights': json['flights'],
        'otgNames': json['otgNames'],
        'periodFrom': json['periodFrom'] == null ? undefined : json['periodFrom'],
        'periodTo': json['periodTo'] == null ? undefined : json['periodTo'],
        'requests': json['requests'],
        'requestsOnBoard': json['requestsOnBoard'],
        'requestsUpcoming': json['requestsUpcoming'],
        'sections': ((json['sections'] as Array<any>).map(OutputUavMissionsReportSectionFromJSON)),
        'shootdowns': json['shootdowns'],
    };
}

export function OutputUavMissionsReportToJSON(value?: OutputUavMissionsReport | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dayStartHour': value['dayStartHour'],
        'days': ((value['days'] as Array<any>).map(OutputUavMissionsReportDayToJSON)),
        'filters': ((value['filters'] as Array<any>).map(OutputUavMissionsReportFilterToJSON)),
        'flights': value['flights'],
        'otgNames': value['otgNames'],
        'periodFrom': value['periodFrom'],
        'periodTo': value['periodTo'],
        'requests': value['requests'],
        'requestsOnBoard': value['requestsOnBoard'],
        'requestsUpcoming': value['requestsUpcoming'],
        'sections': ((value['sections'] as Array<any>).map(OutputUavMissionsReportSectionToJSON)),
        'shootdowns': value['shootdowns'],
    };
}

